export default function SearchApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function searchChildren(searchTerm, maxResults=0, centreId = null) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/search/children?searchTerm=${encodeURIComponent(searchTerm)}&maxResults=${maxResults}${centreId ? `&centreId=${centreId}` : ''}`));
        });
    }

    function getChildDetails(childId){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/search/ChildById?childId=${childId}`));
        });
    }
    
    return {
        searchChildren,
        getChildDetails
    }

}